import { render, staticRenderFns } from "./approvalCommentsAndBtns.vue?vue&type=template&id=35b30f9e&"
import script from "./approvalCommentsAndBtns.vue?vue&type=script&lang=js&"
export * from "./approvalCommentsAndBtns.vue?vue&type=script&lang=js&"
import style0 from "./approvalCommentsAndBtns.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35b30f9e')) {
      api.createRecord('35b30f9e', component.options)
    } else {
      api.reload('35b30f9e', component.options)
    }
    module.hot.accept("./approvalCommentsAndBtns.vue?vue&type=template&id=35b30f9e&", function () {
      api.rerender('35b30f9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/Wrokflow/approvalCommentsAndBtns.vue"
export default component.exports